var map = {
	"./undraw_Forms_re_pkrt.svg": 77931,
	"./undraw_QA_engineers_dg5p.svg": 30580,
	"./undraw_add_to_cart_re_wrdo.svg": 39107,
	"./undraw_building_blocks_n-0-nc.svg": 67775,
	"./undraw_businessman_97x4.svg": 55741,
	"./undraw_businessman_re_mlee.svg": 41708,
	"./undraw_composition_re_4o4o.svg": 2897,
	"./undraw_deliveries_131a.png": 38343,
	"./undraw_deliveries_131a.svg": 60945,
	"./undraw_deliveries_2r4y.svg": 37798,
	"./undraw_delivery_truck_vt6p.svg": 67139,
	"./undraw_gone_shopping_vwmc.svg": 42690,
	"./undraw_mail_sent_re_0ofv.svg": 98158,
	"./undraw_on_the_way_re_swjt.svg": 93796,
	"./undraw_online_groceries_a02y.svg": 98540,
	"./undraw_order_delivered_p6ba.svg": 54833,
	"./undraw_order_delivered_re_v4ab.svg": 9,
	"./undraw_product_tour_foyt.svg": 13011,
	"./undraw_quite_town_mg2q.svg": 6975,
	"./undraw_shopping_app_flsj.svg": 83038,
	"./undraw_social_user_lff0.svg": 21480,
	"./undraw_successful_purchase_re_mpig.svg": 10624,
	"./undraw_successful_purchase_uyin.svg": 2172,
	"./undraw_takeout_boxes_ap54.svg": 94156,
	"./undraw_team_page_re_cffb.svg": 74947,
	"./undraw_team_re_0bfe.svg": 10301,
	"./undraw_wishlist_re_m7tv.svg": 8536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36698;